import React, { useEffect, useState } from "react";
import { fetchCustomizedTrips } from "../services/Customizedtripslistfilter";
import { API_BASE } from "../api/apiConfig";

const Customizedtripslist = () => {
  const [activeTab, setActiveTab] = useState("international");

  const [trips, setTrips] = useState([]);
  const [filteredTrips, setFilteredTrips] = useState([]);

  const [countries, setCountries] = useState([]);
  const [cities, setCities] = useState([]);

  const [selectedCountry, setSelectedCountry] = useState("All Countries");
  const [selectedCity, setSelectedCity] = useState("All Cities");

  const [loading, setLoading] = useState(true);

  /* ================= FETCH DATA ================= */
  useEffect(() => {
    loadTrips();
  }, []);

  const loadTrips = async (type = "international") => {
  const res = await fetchCustomizedTrips(type);
  if (res?.status) {
    setTrips(res.data);
    setFilteredTrips(res.data);

    setCountries([
      ...new Set(res.data.map(t => t.country_name).filter(Boolean)),
    ]);

    setCities([
      ...new Set(res.data.map(t => t.city).filter(Boolean)),
    ]);
  }
  setLoading(false);
};

useEffect(() => {
  loadTrips(activeTab);
}, [activeTab]);

  /* ================= FILTER LOGIC ================= */
  useEffect(() => {
    if (activeTab === "international") {
      setFilteredTrips(
        selectedCountry === "All Countries"
          ? trips
          : trips.filter(t => t.country_name === selectedCountry)
      );
    } else {
      setFilteredTrips(
        selectedCity === "All Cities"
          ? trips
          : trips.filter(t => t.city === selectedCity)
      );
    }
  }, [activeTab, selectedCountry, selectedCity, trips]);

  const activeTabLabel =
    activeTab === "international" ? "International" : "Domestic";

  if (loading) {
    return <p className="text-center py-10">Loading trips...</p>;
  }

  /* ================= UI ================= */
  return (
    
    <div className="lg:hidden">
        <div className="relative h-52 overflow-hidden">
          <img
            alt="Customized Trips"
            decoding="async"
            data-nimg="fill"
            className="object-cover"
            style={{
              position: "absolute",
              height: "100%",
              width: "100%",
              inset: 0,
              color: "transparent"
            }}
            src="/assets/images/scenic-travel-destination-mountain-lake-sunset.jpg"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/60" />
          <div className="relative h-full flex flex-col items-center justify-center px-4">
            <div className="text-center mb-3">
              <h1 className="text-xl font-bold text-white mb-1">PLAN YOUR</h1>
              <h2 className="text-3xl font-extrabold text-yellow-400 drop-shadow-[0_2px_4px_rgba(0,0,0,0.8)]">
                Customized
              </h2>
              <h1 className="text-xl font-bold text-white">TRIPS</h1>
            </div>
            <button className="bg-white/95 backdrop-blur-sm text-teal-600 px-6 py-2.5 rounded-full text-sm font-semibold shadow-lg hover:bg-white transition-all flex items-center gap-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={24}
                height={24}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-map-pin h-4 w-4"
              >
                <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
                <circle cx={12} cy={10} r={3} />
              </svg>
              Quick Inquiry
            </button>
          </div>
        </div>
        <div className="px-4 py-4 bg-white border-b mb-3 overflow-x-visible">
          <div className="flex gap-3 justify-center mb-4">
            <button
              onClick={() => {
                setActiveTab("international");
                setSelectedCity("All Cities");
              }}
              className={`flex-1 py-2.5 px-4 rounded-full text-sm font-semibold transition-all ${
                activeTab === "international"
                  ? "bg-teal-500 text-white shadow-md"
                  : "bg-slate-100 text-slate-700 hover:bg-slate-200"
              }`}
            >
              International
            </button>

            <button
              onClick={() => {
                setActiveTab("domestic");
                setSelectedCountry("All Countries");
              }}
              className={`flex-1 py-2.5 px-4 rounded-full text-sm font-semibold transition-all ${
                activeTab === "domestic"
                  ? "bg-teal-500 text-white shadow-md"
                  : "bg-slate-100 text-slate-700 hover:bg-slate-200"
              }`}
            >
              Domestic
            </button>
          </div>
        {activeTab === "international" && (
          <div className="mt-3">
            <h4 className="text-xs font-bold text-slate-700 mb-2.5 uppercase tracking-wide">
              Select Country
            </h4>
            <div className="flex flex-nowrap gap-2 overflow-x-scroll no-scrollbar pb-2"
  style={{ WebkitOverflowScrolling: "touch" }}>
             <button
                onClick={() => setSelectedCountry("All Countries")}
                className={`px-4 py-2 rounded-full text-xs font-medium whitespace-nowrap transition-all ${
                  selectedCountry === "All Countries"
                    ? "bg-teal-500 text-white shadow-sm"
                    : "bg-slate-100 text-slate-700 hover:bg-slate-200"
                }`}
              >
                All Countries
              </button>

              {countries.map(country => (
                <button
                  key={country}
                  onClick={() => setSelectedCountry(country)}
                  className={`px-4 py-2 rounded-full text-xs font-medium whitespace-nowrap transition-all flex-shrink-0 ${
                    selectedCountry === country
                      ? "bg-teal-500 text-white shadow-sm"
                      : "bg-slate-100 text-slate-700 hover:bg-slate-200"
                  }`}
                >
                  {country}
                </button>
              ))}
            </div>
          </div>
        )}

        {activeTab === "domestic" && (
          <div className="mt-3">
            <h4 className="text-xs font-bold text-slate-700 mb-2.5 uppercase tracking-wide">
              Select City
            </h4>
            <div className="flex flex-nowrap gap-2 overflow-x-scroll no-scrollbar pb-2"
  style={{ WebkitOverflowScrolling: "touch" }}>
             <button
                onClick={() => setSelectedCity("All Cities")}
                className={`px-4 py-2 rounded-full text-xs font-medium whitespace-nowrap transition-all ${
                  selectedCity === "All Cities"
                    ? "bg-teal-500 text-white shadow-sm"
                    : "bg-slate-100 text-slate-700 hover:bg-slate-200"
                }`}
              >
                All Cities
              </button>

              {cities.map(city => (
                <button
                  key={city}
                  onClick={() => setSelectedCity(city)}
                  className={`px-4 py-2 rounded-full text-xs font-medium whitespace-nowrap transition-all ${
                    selectedCity === city
                      ? "bg-teal-500 text-white shadow-sm"
                      : "bg-slate-100 text-slate-700 hover:bg-slate-200"
                  }`}
                >
                  {city}
                </button>
              ))}
            </div>
          </div>
        )}
        </div>
        <div className="px-4 pb-20 pt-2 bg-slate-50">
          <p className="text-xs font-semibold text-slate-700 mb-3 uppercase tracking-wide">
            {filteredTrips.length} Packages Available
          </p>
          <div className="space-y-5">

          {filteredTrips.map((trip) => (
            <a key={trip.id} className="block mb-4" href={`/CustomizedTripsDtl/${activeTabLabel}/${activeTab === "international" ? trip.id : trip.id}`}>
              <div className="rounded-lg border bg-card text-card-foreground overflow-hidden shadow-sm hover:shadow-md transition-all border-slate-200">
                <div className="relative h-44">
                  <img
                    alt={trip.name}
                    loading="lazy"
                    decoding="async"
                    data-nimg="fill"
                    className="object-cover"
                    style={{
                      position: "absolute",
                      height: "100%",
                      width: "100%",
                      inset: 0,
                      color: "transparent"
                    }}
                    src={
                    trip.images
                      ? `${API_BASE}${trip.images}`
                      : `${API_BASE}default.jpg`
                  }
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" />
                  <div className="absolute bottom-0 left-0 right-0 p-3">
                    <h3 className="font-bold text-white text-sm leading-tight mb-1">
                      {trip.name}
                    </h3>
                    <div className="flex items-center gap-2 text-xs text-white/90">
                      <span className="flex items-center gap-1">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width={24}
                          height={24}
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth={2}
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="lucide lucide-map-pin h-3 w-3"
                        >
                          <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
                          <circle cx={12} cy={10} r={3} />
                        </svg>
                        {activeTab === "international" ? trip.country_name : trip.city}
                      </span>
                      <span>•</span>
                      <span>{trip.no_of_days} Days</span>
                    </div>
                  </div>
                </div>
                <div className="p-3 bg-white">
                {trip.spots && Number(trip.spots) !== 0 && (
                  <div className="flex items-center gap-2 text-xs text-slate-600 mb-2">
                    <span className="flex items-center gap-1">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="lucide lucide-users h-3 w-3"
                      >
                        <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                        <circle cx={9} cy={7} r={4} />
                        <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                        <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                      </svg>
                      {trip.spots} People
                    </span>
                    <span>•</span>
                    <div className="inline-flex items-center rounded-full border font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent hover:bg-secondary/80 text-[10px] px-1.5 py-0 h-4 bg-teal-50 text-teal-700">
                      {activeTab === "international"} {activeTabLabel}
                    </div>
                  </div>
                  )}
                  

              {trip.descriptions?.[0]?.activity && (
              (() => {
                const activities = trip.descriptions[0].activity
                  .split("@@")
                  .map(a => a.trim())
                  .filter(Boolean)
                  .slice(0, 2); // ✅ only 2

                if (activities.length === 0) return null;

                return (
                  <div className="flex items-start gap-2 mb-2.5">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-check-circle h-3 w-3 text-teal-600 mt-0.5 flex-shrink-0"
                    >
                      <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                      <path d="m9 11 3 3L22 4" />
                    </svg>
                    <p className="text-xs text-slate-600 line-clamp-2 leading-relaxed">
                      {activities.join(" • ")}
                    </p>
                  </div>
                  );
                  })()
                )}


                  <div className="flex items-center justify-between pt-2 border-t border-slate-100">
                    <div>
                    {Number(trip.charges) !== 0 && (
                      <p className="text-[10px] text-slate-500 uppercase tracking-wide mb-0.5">
                        Starting From
                      </p>
                    )}
                      <p className="text-sm font-bold text-slate-800">
                        {Number(trip.charges) === 0 ? "Customised" : `₹${trip.charges}`}
                      </p>
                    </div>
                    <button className="inline-flex items-center justify-center whitespace-nowrap font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 rounded-md px-3 h-7 text-xs bg-teal-500 hover:bg-teal-600 text-white">
                      Customize
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="lucide lucide-chevron-right h-3 w-3 ml-1"
                      >
                        <path d="m9 18 6-6-6-6" />
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            </a>
          ))}

          </div>
        </div>
      </div>

  );
};

export default Customizedtripslist;
